import { IFilterElement } from "@saleor/components/Filter";
import {
  RemittanceRunnerListUrlEnum,
  RemittanceRunnerListUrlFilters,
  RemittanceRunnerListUrlFiltersWithMultipleValuesEnum
} from "@saleor/remittanceRunner/url";
import { CourierTypeEnum, DeliveryTypeEnum } from "@saleor/types/globalTypes";
import {
  getMinMaxQueryParam,
  getMultipleEnumValueQueryParam,
  getMultipleTextFieldQueryParam,
  getMultipleValueQueryParam,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

import { RemittanceRunnerFilterKeys } from "./filters";

function getStaffFullName(
  filter: IFilterElement<RemittanceRunnerFilterKeys>,
  firstNameEnum: RemittanceRunnerListUrlEnum,
  lastNameEnum: RemittanceRunnerListUrlEnum
): any {
  const firstName = filter.active
    ? getMultipleTextFieldQueryParam(filter, firstNameEnum) || ""
    : undefined;

  const lastName = filter.active
    ? getMultipleTextFieldQueryParam(filter, lastNameEnum) || ""
    : undefined;

  return {
    [firstNameEnum]: firstName,
    [lastNameEnum]: lastName
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<RemittanceRunnerFilterKeys>
): RemittanceRunnerListUrlFilters {
  const { name } = filter;
  switch (name) {
    case RemittanceRunnerFilterKeys.motherOrder:
      return getSingleValueQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.motherOrder
      );

    case RemittanceRunnerFilterKeys.status:
      return getSingleValueQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.status
      );

    case RemittanceRunnerFilterKeys.dateShipped:
      return getMinMaxQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.dateShippedFrom,
        RemittanceRunnerListUrlEnum.dateShippedTo
      );

    case RemittanceRunnerFilterKeys.dateCompleted:
      return getMinMaxQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.dateCompletedFrom,
        RemittanceRunnerListUrlEnum.dateCompletedTo
      );

    case RemittanceRunnerFilterKeys.deliveryType:
      return getMultipleEnumValueQueryParam(
        filter,
        RemittanceRunnerListUrlFiltersWithMultipleValuesEnum.deliveryType,
        DeliveryTypeEnum
      );

    case RemittanceRunnerFilterKeys.amount:
      return getSingleValueQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.amount
      );

    case RemittanceRunnerFilterKeys.remittanceId:
      return getSingleValueQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.remittanceId
      );

    case RemittanceRunnerFilterKeys.remittanceDate:
      return getMinMaxQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.remittanceDateFrom,
        RemittanceRunnerListUrlEnum.remittanceDateTo
      );

    case RemittanceRunnerFilterKeys.remitterName:
      return getStaffFullName(
        filter,
        RemittanceRunnerListUrlEnum.remitterFirstName,
        RemittanceRunnerListUrlEnum.remitterLastName
      );

    case RemittanceRunnerFilterKeys.dispatcherName:
      return getStaffFullName(
        filter,
        RemittanceRunnerListUrlEnum.dispatcherFirstName,
        RemittanceRunnerListUrlEnum.dispatcherLastName
      );

    case RemittanceRunnerFilterKeys.riderName:
      return getStaffFullName(
        filter,
        RemittanceRunnerListUrlEnum.riderFirstName,
        RemittanceRunnerListUrlEnum.riderLastName
      );

    case RemittanceRunnerFilterKeys.mall:
      return getMultipleValueQueryParam(
        filter,
        RemittanceRunnerListUrlFiltersWithMultipleValuesEnum.mall
      );

    case RemittanceRunnerFilterKeys.isPaymentCollected:
      return getSingleValueQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.isPaymentCollected
      );

    case RemittanceRunnerFilterKeys.createdDate:
      return getMinMaxQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.createdDateFrom,
        RemittanceRunnerListUrlEnum.createdDateTo
      );

    case RemittanceRunnerFilterKeys.hasReceipt:
      return getSingleValueQueryParam(
        filter,
        RemittanceRunnerListUrlEnum.hasReceipt
      );

    case RemittanceRunnerFilterKeys.companyName:
      return getMultipleEnumValueQueryParam(
        filter,
        RemittanceRunnerListUrlFiltersWithMultipleValuesEnum.companyName,
        CourierTypeEnum
      );
  }
}
